import { get as getItem, set as setItem } from './localStorage';

import { STORAGE_KEY } from './fritsAuth';

const ALLOWED_ORIGINS_DEV = [
  // ikbenfrits.github.io local test
  'http://127.0.0.1:7700',
  // vue dev server
  'https://localhost:3801',
  // nuxt dev server
  'https://localhost:3901',
];

const ALLOWED_ORIGINS = [
  process.env.DOMAIN,
  'https://www.ikbenfrits.nl',
  'https://app.ikbenfrits.nl',
  'https://www.hypotheekadviesconsumentenbond.nl',
  'https://www.frits.io',
  'https://app.frits.io',
  'https://www.cbhs.nl',
  'https://www.cbhs.io',
  'https://ikbenfrits.github.io',
  'https://www.consumentenbond.nl',
  'https://hubspot.frits.io',
  'https://ikbenfrits-25374578.hs-sites-eu1.com',
  'http://vbo.nl.local',
  'https://www.vbo.nl',
  'https://walterliving.com',
  'https://staging.walterliving.com',
  'https://dyme.app',
  'https://glashaven.nl',
].filter(Boolean);

export function isAllowedOrigin(origin) {
  origin = origin.replace(/\/$/, '');

  if (ALLOWED_ORIGINS.includes(origin))
    return true;

  if (process.env.NODE_ENV === 'development' && ALLOWED_ORIGINS_DEV.includes(origin))
    return true;

  return origin.endsWith('.frits.io')
    || origin.endsWith('.cbhs.io')
    || origin.endsWith('.consumentenbond.nl');
}

export function fritsMessageHandler({ iframe, $bus, origin, data, source }) {
  if (!isAllowedOrigin(origin) || !data.fritsMessage || iframe.contentWindow !== source)
    return;

  return $bus[data.message.event].emit(data.message);
}

const PARENT_RESOURCE_HANDLERS = {
  getFritsAuth: () => {
    return getItem(STORAGE_KEY, null);
  },
  setFritsAuth: ({ value }) => {
    setItem(STORAGE_KEY, value);

    return getItem(STORAGE_KEY, null);
  },
  redirect: () => {},
  scrollTo: () => {},
};

export function fritsParentResourceHandler({ iframe, origin, data, source }) {
  if (!isAllowedOrigin(origin) || !data.fritsParentResource || iframe.contentWindow !== source)
    return;

  if (!PARENT_RESOURCE_HANDLERS[data.key])
    throw new Error(`Parent resource handler ${data.key} not defined`);

  const value = PARENT_RESOURCE_HANDLERS[data.key](data);

  source.postMessage({ key: data.key, value, fritsParentResource: true }, origin);
}

export function initIframeEventListener({ iframe, $bus }) {
  global.addEventListener('message', ({ origin, data, source }) => {
    fritsMessageHandler({ iframe, $bus, origin, data, source });
    fritsParentResourceHandler({ iframe, origin, data, source });
  });
}
